import {
  animate,
  sequence,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ChatService, Message } from 'src/app/chat.service';
import { ToggleService } from 'src/app/services/toggle.service';

@Component({
  selector: 'app-star-rating-modal',
  templateUrl: './star-rating-modal.component.html',
  styleUrls: ['./star-rating-modal.component.css'],
  animations: [
    trigger('rowsAnimation', [
      transition('void => *', [
        style({
          height: '*',
          opacity: '0',
          transform: 'translateX(-550px)',
          'box-shadow': 'none',
        }),
        sequence([
          animate(
            '.35s ease',
            style({
              height: '*',
              opacity: '.2',
              transform: 'translateX(0)',
              'box-shadow': 'none',
            })
          ),
          animate(
            '.35s ease',
            style({ height: '*', opacity: 1, transform: 'translateX(0)' })
          ),
        ]),
      ]),
    ]),
  ],
})
export class StarRatingModalComponent implements OnInit {
  starNon = [];
  stars = [1, 1, 1, 1, 1];
  @Output() clearMessages = new EventEmitter<any>();
  rating: any;
  sessionId: string;
  question1 = 'Please Can you rate our Customer Services';
  question2 = 'The chatbot understood me well';
  question3 = 'Chatbot responses were useful, appropriate and informative';
  questionsRating = {
    question1: 0,
    question2: 0,
    question3: 0
  };
  currentQuestion = 'question1';
  showFeedbackInput = false;
  showStars = true;
  showNextButton = true;
  feedback: string;
  currentStep = 1;
  constructor(
    private chat: ChatService,
    private readonly toggleService: ToggleService
  ) {}

  ngOnInit() {
    this.rating = 5;
    if (localStorage.getItem('sessionId')) {
      this.sessionId = localStorage.getItem('sessionId');
    }
  }

  triggerRatingModule(starRatingModuleTriggerCount) {
    if (starRatingModuleTriggerCount === 0) {
      const element: HTMLElement = document.getElementById(
        'starRating'
      ) as HTMLElement;
      console.log('In triggerRatingModule 1');
      element.click();
    }
  }

  postUserRating() {
    this.chat.postUserRating(this.rating, this.feedback).subscribe((data) => {
      console.log('ratingRes', data);
    });
    const element: HTMLElement = document.getElementById(
      'closeModel'
    ) as HTMLElement;
    element.click();
    const botMessage = new Message(
      'Thank you for your feedback',
      'bot',
      new Date().getTime(),
      null,
      null,
      null,
      true
    );
    this.chat.update(botMessage);
    this.countStarts(-1);
    // let element1: HTMLElement = document.getElementById("submitOpenLink") as HTMLElement
    // element1.click()
    setTimeout(() => {
      const botBody = document.getElementById('content');
      botBody.scrollTop = botBody.scrollHeight;
      this.starNon = [];
      this.stars = [1, 1, 1, 1, 1];
      this.rating = 5;
      this.feedback = '';
      this.showStars = true;
      this.currentQuestion = 'question1';
      this.showNextButton = true;
      this.showFeedbackInput = false;
      this.currentStep = 1;
    }, 100);
    setTimeout(() => {
      this.clearMessages.emit();
      this.toggleService.toggleChatbot(2);
    }, 4000);
  }

  countStarts(index, type: string = null) {
    console.log('Rating', index + 1);
    this.rating = index + 1;
    if (type === 'NON') {
      console.log('in NON');
      // @ts-ignore
      if (this.starNon.length !== 5) {
        index = this.stars.length + index;
      }
      const target_index = index + 1;
      this.starNon = [];
      for (let i = 0; i < 5 - target_index; i++) {
        // @ts-ignore
        this.starNon.push(1);
      }
      this.stars = [];
      for (let i = 0; i <= index; i++) {
        // @ts-ignore
        this.stars.push(1);
      }
      console.log(target_index);
    } else {
      console.log('OUT NON');

      if (this.stars.length !== index + 1) {
        // @ts-ignore
        if (this.stars.length !== 5) {
          index = this.starNon.length + index - 1;
        }
        let target_index = index;
        this.stars = [];
        // @ts-ignore
        if (this.starNon.length === 2 && target_index === 2) {
          target_index = target_index - 1;
        } else if (this.starNon.length === 3 && target_index === 2) {
          target_index = target_index - 2;
        } else if (this.starNon.length === 2 && target_index === 1) {
          target_index = target_index - 1;
          console.log('inside Condition');
        }
        console.log('star non length', this.starNon.length);
        for (let i = 0; i <= target_index; i++) {
          // @ts-ignore
          this.stars.push(1);
        }

        this.starNon = [];
        for (let i = 0; i < 5 - (target_index + 1); i++) {
          // @ts-ignore
          this.starNon.push(1);
        }
        console.log('Target', target_index);
      }
    }
  }

  nextQuestion(): void {
    this.showStars = false;
    this.showNextButton = false;

    setTimeout(() => {
      this.currentStep += 1;
      if (this.rating < 5) {
        this.showNextButton = false;
        this.showFeedbackInput = true;
      } else {
        this.postUserRating();
      }
      // this.currentStep += 1;
      // switch(this.currentQuestion) {
      //   case 'question1': this.currentQuestion = 'question2';
      //     this.showStars = true;
      //     this.showNextButton = true;
      //     this.questionsRating['question1'] = this.rating;
      //   break;
      //   case 'question2': this.currentQuestion = 'question3';
      //     this.showStars = true;
      //     this.showNextButton = true;
      //     this.questionsRating['question2'] = this.rating;
      //   break;
      //   case 'question3': this.showFeedbackInput = true;
      //     this.currentQuestion = 'question1';
      //     this.showStars = false;
      //     this.showNextButton = false;
      //     this.questionsRating['question3'] = this.rating;
      //   break;
      // }
      // this.starNon = [];
      // this.stars = [1, 1, 1, 1, 1];
      // this.rating = 5;
    }, 100);
  }
}
